var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrajavaniOtpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#FFF0D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 88,
    height: 88,
    rx: 44,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.334 47.9993C31.334 41.7139 31.334 38.5713 33.2866 36.6186C35.2392 34.666 38.3819 34.666 44.6673 34.666H51.334C57.6193 34.666 60.7621 34.666 62.7146 36.6186C64.6673 38.5713 64.6673 41.7139 64.6673 47.9993C64.6673 54.2847 64.6673 57.4275 62.7146 59.38C60.7621 61.3327 57.6193 61.3327 51.334 61.3327H44.6673C38.3819 61.3327 35.2392 61.3327 33.2866 59.38C31.334 57.4275 31.334 54.2847 31.334 47.9993Z",
    stroke: "#1C274C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9992 44.666V51.3327M45.1118 46.3327L50.8853 49.666M50.8848 46.3327L45.1113 49.666",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2198 44.666V51.3327M36.3324 46.3327L42.1059 49.666M42.1055 46.3327L36.332 49.666",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7804 44.666V51.3327M53.8929 46.3327L59.6664 49.666M59.6661 46.3327L53.8926 49.666",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrajavaniOtpIcon);
export default __webpack_public_path__ + "static/media/prajavani-otp-icon.dc6d7311d9c5a434da422b3f6d9d8b8e.svg";
export { ForwardRef as ReactComponent };